
        var result = require("!!../../../../node_modules/css-loader/index.js!./customer-satisfaction-survey.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/marketing/customer-satisfaction-survey/customer-satisfaction-survey.component.css
// module id = 2537
// module chunks = 1